import { queryOptions, useQuery } from '@tanstack/vue-query';
import type { Client } from 'openapi-fetch';
import { unwrapResponseOrThrow } from '~/utils/unwrapResponse';
import type { paths } from '~~/types/Api';
import { ensureCountryIsoCode } from '~~/types/ApiCountryCode';

export type UsePublisherDataQueryOptions = {
	enabled?: MaybeRef<boolean>;
};

export type CreatePublisherDataQueryOptions = {
	apiClient: Client<paths>;
} & UsePublisherDataQueryOptions;

export const createPublisherDataQuery = (
	options: CreatePublisherDataQueryOptions,
) => queryOptions({
	queryKey: ['publisherdata'],
	queryFn: async () => options.apiClient
		.GET('/publisherdata/all')
		.then(unwrapResponseOrThrow)
		.then((data) => data.map((d) => ({ ...d, country: ensureCountryIsoCode(d.country) }))),
	enabled: options.enabled,
});

export const usePublisherDataQuery = (options?: UsePublisherDataQueryOptions) => {
	const { $api } = useNuxtApp();

	const query = useQuery(createPublisherDataQuery({ apiClient: $api, ...options }));

	return query;
};
